import { ref, watch, type Ref } from 'vue';

export type BookedRange = { checkin: string; checkout: string };

export function useBookedDates(listingId: Ref<number | null>, fromIso: Ref<string>, toIso: Ref<string>) {
  const booked = ref<BookedRange[]>([]);
  const pending = ref(false);
  const error = ref<Error | null>(null);

  const fetchBooked = async () => {
    // Skip while any part of the window is unset (QuoteWidget populates
    // `today` in onMounted, so the first watch tick runs with empty strings).
    if (listingId.value == null || !fromIso.value || !toIso.value) return;
    pending.value = true;
    error.value = null;
    try {
      const qs = new URLSearchParams({ from: fromIso.value, to: toIso.value });
      const res = await $fetch<{ booked: BookedRange[] }>(
        `/api/availability/${listingId.value}/booked-dates?${qs.toString()}`,
      );
      booked.value = res.booked ?? [];
    } catch (e) {
      error.value = e instanceof Error ? e : new Error(String(e));
      booked.value = [];
    } finally {
      pending.value = false;
    }
  };

  watch([listingId, fromIso, toIso], fetchBooked, { immediate: true });

  return { booked, pending, error, refresh: fetchBooked };
}
